import { TranslationFunction } from '../../../common/types'
import { LivePricing } from '../../../hooks/combo-pricing'
import { FormattedLivePricingDataTransport } from '../../../models/pricing/live-pricing-formatter'
import { FormattedPropertyData } from '../../../models/property-details-page/property-details-model'

type Params = {
    selectedIndex: number
    isComboListing: boolean
    unitsData: FormattedPropertyData[]
    propertyDetails: FormattedPropertyData | null
    normalPricingDetails: FormattedLivePricingDataTransport | null
    isNormalPricingLoading: boolean
    normalPricingErrorCode: number | null
    comboPrices: Map<string, LivePricing>
    t: TranslationFunction
}

export const getUnitBasedProps = ({
    selectedIndex,
    isComboListing,
    unitsData,
    propertyDetails,
    normalPricingDetails,
    isNormalPricingLoading,
    normalPricingErrorCode,
    comboPrices,
    t,
}: Params) => {
    const selectedUnitData =
        selectedIndex !== -1 && unitsData && 0 <= selectedIndex && selectedIndex < unitsData.length
            ? unitsData[selectedIndex]
            : null

    const comboPriceData = selectedUnitData ? comboPrices.get(selectedUnitData.id) || null : null

    const pricingDetails = !isComboListing ? normalPricingDetails : comboPriceData?.pricingDetails || null

    const isPricingLoading = !isComboListing ? isNormalPricingLoading : comboPriceData?.isLoading || false

    const pricingErrorCode = !isComboListing ? normalPricingErrorCode : comboPriceData?.error ?? null

    const bookingType = !isComboListing ? propertyDetails?.bookingType || null : selectedUnitData?.bookingType || null

    const selectedUnitName = selectedIndex === -1 ? t('entitySection.title') : selectedUnitData?.title || ''

    const offers = !isComboListing ? propertyDetails?.offers || null : selectedUnitData?.offers || null

    const showIncludedVatInformation = !isComboListing
        ? propertyDetails?.general.showIncludedVatInformation || false
        : selectedUnitData?.general.showIncludedVatInformation || false

    const traumPaymentsActivated = !isComboListing
        ? propertyDetails?.general.traumPaymentsActivated || false
        : selectedUnitData?.general.traumPaymentsActivated || false

    const showAvailabilityCalendar = !isComboListing
        ? propertyDetails?.general.showAvailabilityCalendar || false
        : selectedUnitData?.general.showAvailabilityCalendar || false

    // In combo listings, user can select the the as per the maxPersion of entity
    const maxPersons = propertyDetails?.stats?.maxPersons

    return {
        pricingDetails,
        isPricingLoading,
        pricingErrorCode,
        bookingType,
        offers,
        showVatTax: showIncludedVatInformation,
        isTraumPaymentEnabled: traumPaymentsActivated,
        showCalendar: showAvailabilityCalendar,
        maxTotalGuests: maxPersons,
        selectedUnitName,
    }
}
